
import React from "react";
import { formatMOQ } from "@/utils/inventory/moqUtils";
import { Scale } from "lucide-react";

interface MOQDisplayProps {
  moq?: number | null;
  showIcon?: boolean;
  showLabel?: boolean;
  className?: string;
}

export const MOQDisplay: React.FC<MOQDisplayProps> = ({
  moq,
  showIcon = false,
  showLabel = false,
  className = "",
}) => {
  const formattedMOQ = formatMOQ(moq);
  
  if (showIcon) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <Scale className="h-4 w-4" />
        {showLabel && <span>MOQ: </span>}
        <span className="font-bold">{formattedMOQ}</span>
      </div>
    );
  }
  
  return (
    <span className={className}>{formattedMOQ}</span>
  );
};

